module.exports = __webpack_public_path__ + "static/media/beleidskeuze_L.796a6127.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/beleidskeuze_L.svg
// module id = 127
// module chunks = 0